import { render, staticRenderFns } from "./OrderDetailPanal.vue?vue&type=template&id=7cfa44b2&scoped=true&"
import script from "./OrderDetailPanal.vue?vue&type=script&lang=js&"
export * from "./OrderDetailPanal.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailPanal.vue?vue&type=style&index=0&id=7cfa44b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cfa44b2",
  null
  
)

export default component.exports